import * as adUI from 'UI/store/ui';

export const state = adUI.state;
export const mutations = adUI.mutations;
export const actions = adUI.actions;
